import { KEY_PERSISTENT_LOCAL_STORAGE } from './index'
import moment from 'moment'
import i18next from 'i18next'
import Either from 'data.either/lib/either'
import backend from '../backend'
import { fetchJsonWithJWT, catchResponse401ResetAuthToken } from '../commons/utils'

const SCREEN_TEMPLATES = 'templates'

/* Application State: Navigation, Modus, ...  */
const appState = {
	state: () => ({
		feedbackMessage: '',
		feedbackVariant: 'warning',
		currentScreen: 'about'
	}),
	getters:{
		version: () => '1.0.4 Build 2023010501',
		urlToApp: () => 'https://epc-qrcode.gurevich.de',
		getFeedbackVariant: state => state.feedbackVariant,
		getFeedbackMessage: state => state.feedbackMessage,
		
		isScreenDashboard:  (state, getters, rootState) => state.currentScreen === 'dashboard',
		isScreenTemplates:  (state, getters, rootState) => state.currentScreen === SCREEN_TEMPLATES,
		isScreenSettings: ( state, getters ) => state.currentScreen === 'settings',
		isScreenAbout: ( state, getters ) => state.currentScreen === 'about',
    
	},
	mutations: {
		currentScreen (state, payload) { state.currentScreen = payload },
		
		feedbackMessage(state, payload = {}) { 
			const { message = '', variant = 'warning' } = payload
			state.feedbackMessage = message 
			state.feedbackVariant = variant
		}
	
	},
	actions: {
		test: (ctx) => console.log('appState - action'),
		
		showDashboard: (ctx, payload) => { ctx.commit('currentScreen', 'dashboard') },
		showTemplates: (ctx, payload) => { ctx.commit('currentScreen', SCREEN_TEMPLATES) },
		showSettings: (ctx, payload) => { ctx.commit('currentScreen', 'settings') },
		showAbout: (ctx, payload) => { ctx.commit('currentScreen', 'about') },

		setFeedbackMessage: (ctx, payload = {}) => { 
			ctx.commit('feedbackMessage', payload)
			const {ttl = 0} = payload
			if(ttl) setTimeout(() => { ctx.commit('feedbackMessage', {}) }, ttl)
		},
		dimissFeedbackMessage: ctx => { ctx.commit('feedbackMessage', {}) },
		resetApp: (ctx) => {
			ctx.commit('restoreFactorySettings') 
			window.localStorage.removeItem(KEY_PERSISTENT_LOCAL_STORAGE)
			window.location.reload()
		}
	}
}

export default appState
